import React, { FC } from 'react';
import { RenewalTotal } from '../utils/renewalTableTileTypes';

export const RenewalLineTotal: FC<{ total?: RenewalTotal }> = ({ total }) => {
    return total ? <TotalCell {...total} /> : <NoTotalCell />;
};

const TotalCell: FC<RenewalTotal> = ({ usageLimitLabel, priceLabel }) => {
    return (
        <td className="renewal-total">
            <b>{usageLimitLabel}</b>
            <br />
            <b>{priceLabel}</b>
        </td>
    );
};

export const NoTotalCell: FC = () => {
    return (
        <td className="renewal-total">
            <div>-</div>
        </td>
    );
};
